import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
    //return new TranslateHttpLoader(httpClient);
    return new TranslateHttpLoader(httpClient, './assets/i18n/', ".json");
}
